import { createApi } from "@reduxjs/toolkit/query/react";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";
import { mapExporterFormResponse } from "@/redux/mappers/Export/CreateNewJob/generalMapper";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const exportIdApi = createApi({
  reducerPath: "exportIdApi",
  baseQuery,
  tagTypes: ["Dashboard", "ExportGeneral"],
  endpoints: (builder) => ({
    // existing list query
    getExportId: builder.query({
      query: () => apiurl.AgGrid_data,
      transformResponse: (response) => {
      },
      providesTags: ["Dashboard"],
    }),

    getExportGeneralById: builder.query({
      query: ({ id }) => `export/general/${id}`,
      transformResponse: (response) => {
        const mapped = response?.data ? mapExporterFormResponse(response.data) : null;
        return mapped;
      },
      providesTags: (result, error, id) => [{ type: "ExportGeneral", id }],
    }),
    
  }),
});

// hooks
export const {
  useGetExportIdQuery,
  useGetExportGeneralByIdQuery,
  useLazyGetExportGeneralByIdQuery, // ✅ add lazy hook
} = exportIdApi;
